// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%2394a3b8%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Aggregation Node Form Styles
 *
 * Layout: overlay > panel (header / scrollable body / pinned footer).
 * Desktop (> 640px): draggable floating panel, two-column field grid.
 * Compact (<= 640px): bottom sheet, single column, no dragging.
 * The breakpoint is mirrored by COMPACT_QUERY in AggregationNodeForm.tsx.
 */

.agg-node-form__overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: var(--cfn-bg-overlay, rgba(2, 6, 23, 0.85));
  display: flex;
  align-items: center;
  justify-content: center;
  animation: agg-node-form-fade-in 0.2s ease;
}

@keyframes agg-node-form-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.agg-node-form,
.agg-node-form *,
.agg-node-form *::before,
.agg-node-form *::after {
  box-sizing: border-box;
}

.agg-node-form {
  display: flex;
  flex-direction: column;
  background: rgba(9, 12, 23, 0.98);
  border: 1px solid rgba(148, 163, 184, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
  color: #f8fafc;
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  overflow: hidden;
}

/* Floating panel (desktop) */
.agg-node-form--panel {
  width: min(640px, calc(100vw - 2rem));
  max-height: calc(var(--app-height, 100dvh) - 2rem);
  border-radius: 12px;
}

/* Bottom sheet (compact); the overlay aligns it to the bottom edge */
.agg-node-form--sheet {
  width: 100%;
  max-height: calc(var(--app-height, 100dvh) * 0.92);
  border-radius: 16px 16px 0 0;
  border-bottom: none;
  padding-bottom: env(safe-area-inset-bottom, 0);
  animation: agg-node-form-slide-up 0.25s ease-out;
}

@keyframes agg-node-form-slide-up {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

/* Header */
.agg-node-form__header {
  position: relative;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.8) 0%, rgba(9, 12, 23, 0.95) 100%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.agg-node-form--panel .agg-node-form__header {
  cursor: move;
  cursor: grab;
}

.agg-node-form--panel .agg-node-form__header:active {
  cursor: grabbing;
}

.agg-node-form--sheet .agg-node-form__header {
  padding-top: 1.25rem;
}

/* Sheet grabber pill, purely decorative */
.agg-node-form__grabber {
  position: absolute;
  top: 0.5rem;
  left: 50%;
  width: 2.5rem;
  height: 0.25rem;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.35);
  transform: translateX(-50%);
}

.agg-node-form__heading {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  min-width: 0;
}

/* Read-only identifier of the structure the node belongs to. Lives in the
   header so it stays visible while the body scrolls and the map is obscured. */
.agg-node-form__structure {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 0.5rem;
  font-size: 0.8125rem;
  color: #cbd5e1;
  cursor: default;
}

.agg-node-form__structure-label {
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}

.agg-node-form__structure-id {
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-weight: 600;
  color: #f8fafc;
}

.agg-node-form__structure-ref {
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  color: #94a3b8;
}

.agg-node-form__title {
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 700;
  color: #f8fafc;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  min-width: 0;
}

.agg-node-form__drag-handle {
  color: #64748b;
  font-size: 1rem;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.agg-node-form__header:hover .agg-node-form__drag-handle {
  opacity: 1;
  color: #94a3b8;
}

.agg-node-form__close {
  flex: 0 0 auto;
  width: 2.25rem;
  height: 2.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #94a3b8;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.agg-node-form__close:hover:not(:disabled) {
  background: rgba(148, 163, 184, 0.12);
  color: #f8fafc;
}

.agg-node-form__close:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Form: header stays, body scrolls, buttons pinned */
.agg-node-form__form {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

.agg-node-form__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: 1.25rem;
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.35) transparent;
}

.agg-node-form__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  -moz-column-gap: 1rem;
       column-gap: 1rem;
  row-gap: 1rem;
}

.agg-node-form__field {
  min-width: 0;
}

.agg-node-form__field--full {
  grid-column: 1 / -1;
}

.agg-node-form__label {
  display: block;
  margin-bottom: 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #cbd5e1;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.agg-node-form__required {
  color: #f87171;
}

.agg-node-form__input,
.agg-node-form__select,
.agg-node-form__textarea {
  width: 100%;
  padding: 0.625rem 0.875rem;
  background: rgba(15, 23, 42, 0.5);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 6px;
  color: #f8fafc;
  font-size: 0.875rem;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.agg-node-form__input:focus,
.agg-node-form__select:focus,
.agg-node-form__textarea:focus {
  outline: none;
  background: rgba(15, 23, 42, 0.7);
  border-color: rgba(59, 130, 246, 0.5);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.agg-node-form__textarea {
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}

.agg-node-form__select {
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  padding-right: 2.5rem;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  text-overflow: ellipsis;
}

.agg-node-form__select:disabled,
.agg-node-form__input:disabled,
.agg-node-form__textarea:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: rgba(15, 23, 42, 0.3);
}

.agg-node-form__input--error,
.agg-node-form__select--error,
.agg-node-form__textarea--error {
  border-color: rgba(239, 68, 68, 0.5);
}

.agg-node-form__input--error:focus,
.agg-node-form__select--error:focus,
.agg-node-form__textarea--error:focus {
  border-color: rgba(239, 68, 68, 0.7);
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.agg-node-form__hint {
  margin-top: 0.375rem;
  font-size: 0.6875rem;
  color: #94a3b8;
  font-style: italic;
}

.agg-node-form__error {
  margin-top: 0.375rem;
  font-size: 0.75rem;
  color: #fca5a5;
  padding: 0.375rem 0.625rem;
  background: rgba(239, 68, 68, 0.1);
  border-left: 3px solid rgba(239, 68, 68, 0.5);
  border-radius: 4px;
}

/* Footer */
.agg-node-form__buttons {
  flex: 0 0 auto;
  display: flex;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-top: 1px solid rgba(148, 163, 184, 0.1);
  background: rgba(9, 12, 23, 0.98);
}

.agg-node-form__button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.agg-node-form__button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.agg-node-form__button--primary {
  background: linear-gradient(135deg, #1d4ed8, #2563eb);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
}

.agg-node-form__button--primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #1e40af, #1d4ed8);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
  transform: translateY(-1px);
}

.agg-node-form__button--secondary {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(148, 163, 184, 0.25);
  color: #e2e8f0;
}

.agg-node-form__button--secondary:hover:not(:disabled) {
  background: rgba(15, 23, 42, 0.8);
  border-color: rgba(148, 163, 184, 0.4);
  color: #f8fafc;
  transform: translateY(-1px);
}

.agg-node-form__spinner {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: agg-node-form-spin 0.6s linear infinite;
}

@keyframes agg-node-form-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Compact: single column, larger touch targets, 16px inputs so iOS Safari
   does not zoom the page when a field is focused. */
@media (max-width: 640px) {
  .agg-node-form__overlay {
    align-items: flex-end;
  }

  .agg-node-form__grid {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 0.875rem;
  }

  .agg-node-form__field--full {
    grid-column: auto;
  }

  .agg-node-form__body {
    padding: 1rem;
  }

  .agg-node-form__input,
  .agg-node-form__select,
  .agg-node-form__textarea {
    font-size: 16px;
    padding: 0.75rem 0.875rem;
  }

  .agg-node-form__buttons {
    padding: 0.75rem 1rem;
  }

  .agg-node-form__button {
    padding: 0.8125rem 1rem;
    font-size: 0.9375rem;
  }
}

/* Short landscape: the panel is still draggable but must fit the screen. */
@media (max-height: 600px) {
  .agg-node-form--panel {
    max-height: calc(var(--app-height, 100dvh) - 1rem);
  }
}

@media (prefers-reduced-motion: reduce) {
  .agg-node-form__overlay,
  .agg-node-form--sheet {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/home/styles/aggregation-node-form.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,0CAA0C;EAC1C,0CAA0C;EAC1C,cAAc;EACd,yGAAyG;EACzG,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,qCAAqC;EACrC,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,WAAW;EACX,kDAAkD;EAClD,4BAA4B;EAC5B,mBAAmB;EACnB,8CAA8C;EAC9C,gDAAgD;AAClD;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,wBAAwB,EAAE;AACjC;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,yFAAyF;EACzF,iDAAiD;EACjD,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;+EAC+E;AAC/E;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,2DAA2D;EAC3D,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,qBAAgB;OAAhB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,0BAA0B;EAC1B,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,2DAA2D;EAC3D,8EAA8E;AAChF;;AAEA;;;EAGE,aAAa;EACb,iCAAiC;EACjC,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,yDAA0L;EAC1L,4BAA4B;EAC5B,yCAAyC;EACzC,qBAAqB;EACrB,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,kCAAkC;EAClC,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;oDACoD;AACpD;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,qCAAqC;IACrC,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;EACtB;AACF;;AAEA,2EAA2E;AAC3E;EACE;IACE,kDAAkD;EACpD;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* Aggregation Node Form Styles\n *\n * Layout: overlay > panel (header / scrollable body / pinned footer).\n * Desktop (> 640px): draggable floating panel, two-column field grid.\n * Compact (<= 640px): bottom sheet, single column, no dragging.\n * The breakpoint is mirrored by COMPACT_QUERY in AggregationNodeForm.tsx.\n */\n\n.agg-node-form__overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: var(--cfn-bg-overlay, rgba(2, 6, 23, 0.85));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: agg-node-form-fade-in 0.2s ease;\n}\n\n@keyframes agg-node-form-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.agg-node-form,\n.agg-node-form *,\n.agg-node-form *::before,\n.agg-node-form *::after {\n  box-sizing: border-box;\n}\n\n.agg-node-form {\n  display: flex;\n  flex-direction: column;\n  background: rgba(9, 12, 23, 0.98);\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);\n  color: #f8fafc;\n  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  overflow: hidden;\n}\n\n/* Floating panel (desktop) */\n.agg-node-form--panel {\n  width: min(640px, calc(100vw - 2rem));\n  max-height: calc(var(--app-height, 100dvh) - 2rem);\n  border-radius: 12px;\n}\n\n/* Bottom sheet (compact); the overlay aligns it to the bottom edge */\n.agg-node-form--sheet {\n  width: 100%;\n  max-height: calc(var(--app-height, 100dvh) * 0.92);\n  border-radius: 16px 16px 0 0;\n  border-bottom: none;\n  padding-bottom: env(safe-area-inset-bottom, 0);\n  animation: agg-node-form-slide-up 0.25s ease-out;\n}\n\n@keyframes agg-node-form-slide-up {\n  from { transform: translateY(100%); }\n  to { transform: translateY(0); }\n}\n\n/* Header */\n.agg-node-form__header {\n  position: relative;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  background: linear-gradient(135deg, rgba(15, 23, 42, 0.8) 0%, rgba(9, 12, 23, 0.95) 100%);\n  border-bottom: 1px solid rgba(148, 163, 184, 0.1);\n  user-select: none;\n}\n\n.agg-node-form--panel .agg-node-form__header {\n  cursor: move;\n  cursor: grab;\n}\n\n.agg-node-form--panel .agg-node-form__header:active {\n  cursor: grabbing;\n}\n\n.agg-node-form--sheet .agg-node-form__header {\n  padding-top: 1.25rem;\n}\n\n/* Sheet grabber pill, purely decorative */\n.agg-node-form__grabber {\n  position: absolute;\n  top: 0.5rem;\n  left: 50%;\n  width: 2.5rem;\n  height: 0.25rem;\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.35);\n  transform: translateX(-50%);\n}\n\n.agg-node-form__heading {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n  min-width: 0;\n}\n\n/* Read-only identifier of the structure the node belongs to. Lives in the\n   header so it stays visible while the body scrolls and the map is obscured. */\n.agg-node-form__structure {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  font-size: 0.8125rem;\n  color: #cbd5e1;\n  cursor: default;\n}\n\n.agg-node-form__structure-label {\n  font-size: 0.6875rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n}\n\n.agg-node-form__structure-id {\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n  font-weight: 600;\n  color: #f8fafc;\n}\n\n.agg-node-form__structure-ref {\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n  color: #94a3b8;\n}\n\n.agg-node-form__title {\n  margin: 0;\n  font-size: 1.0625rem;\n  font-weight: 700;\n  color: #f8fafc;\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  min-width: 0;\n}\n\n.agg-node-form__drag-handle {\n  color: #64748b;\n  font-size: 1rem;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n}\n\n.agg-node-form__header:hover .agg-node-form__drag-handle {\n  opacity: 1;\n  color: #94a3b8;\n}\n\n.agg-node-form__close {\n  flex: 0 0 auto;\n  width: 2.25rem;\n  height: 2.25rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #94a3b8;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.agg-node-form__close:hover:not(:disabled) {\n  background: rgba(148, 163, 184, 0.12);\n  color: #f8fafc;\n}\n\n.agg-node-form__close:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Form: header stays, body scrolls, buttons pinned */\n.agg-node-form__form {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.agg-node-form__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  padding: 1.25rem;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(148, 163, 184, 0.35) transparent;\n}\n\n.agg-node-form__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: 1rem;\n  row-gap: 1rem;\n}\n\n.agg-node-form__field {\n  min-width: 0;\n}\n\n.agg-node-form__field--full {\n  grid-column: 1 / -1;\n}\n\n.agg-node-form__label {\n  display: block;\n  margin-bottom: 0.375rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #cbd5e1;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.agg-node-form__required {\n  color: #f87171;\n}\n\n.agg-node-form__input,\n.agg-node-form__select,\n.agg-node-form__textarea {\n  width: 100%;\n  padding: 0.625rem 0.875rem;\n  background: rgba(15, 23, 42, 0.5);\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  border-radius: 6px;\n  color: #f8fafc;\n  font-size: 0.875rem;\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n}\n\n.agg-node-form__input:focus,\n.agg-node-form__select:focus,\n.agg-node-form__textarea:focus {\n  outline: none;\n  background: rgba(15, 23, 42, 0.7);\n  border-color: rgba(59, 130, 246, 0.5);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.agg-node-form__textarea {\n  resize: vertical;\n  min-height: 80px;\n  font-family: inherit;\n}\n\n.agg-node-form__select {\n  cursor: pointer;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2394a3b8' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  padding-right: 2.5rem;\n  appearance: none;\n  text-overflow: ellipsis;\n}\n\n.agg-node-form__select:disabled,\n.agg-node-form__input:disabled,\n.agg-node-form__textarea:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background-color: rgba(15, 23, 42, 0.3);\n}\n\n.agg-node-form__input--error,\n.agg-node-form__select--error,\n.agg-node-form__textarea--error {\n  border-color: rgba(239, 68, 68, 0.5);\n}\n\n.agg-node-form__input--error:focus,\n.agg-node-form__select--error:focus,\n.agg-node-form__textarea--error:focus {\n  border-color: rgba(239, 68, 68, 0.7);\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.agg-node-form__hint {\n  margin-top: 0.375rem;\n  font-size: 0.6875rem;\n  color: #94a3b8;\n  font-style: italic;\n}\n\n.agg-node-form__error {\n  margin-top: 0.375rem;\n  font-size: 0.75rem;\n  color: #fca5a5;\n  padding: 0.375rem 0.625rem;\n  background: rgba(239, 68, 68, 0.1);\n  border-left: 3px solid rgba(239, 68, 68, 0.5);\n  border-radius: 4px;\n}\n\n/* Footer */\n.agg-node-form__buttons {\n  flex: 0 0 auto;\n  display: flex;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  border-top: 1px solid rgba(148, 163, 184, 0.1);\n  background: rgba(9, 12, 23, 0.98);\n}\n\n.agg-node-form__button {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.625rem 1.25rem;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.agg-node-form__button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.agg-node-form__button--primary {\n  background: linear-gradient(135deg, #1d4ed8, #2563eb);\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);\n}\n\n.agg-node-form__button--primary:hover:not(:disabled) {\n  background: linear-gradient(135deg, #1e40af, #1d4ed8);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);\n  transform: translateY(-1px);\n}\n\n.agg-node-form__button--secondary {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  color: #e2e8f0;\n}\n\n.agg-node-form__button--secondary:hover:not(:disabled) {\n  background: rgba(15, 23, 42, 0.8);\n  border-color: rgba(148, 163, 184, 0.4);\n  color: #f8fafc;\n  transform: translateY(-1px);\n}\n\n.agg-node-form__spinner {\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: agg-node-form-spin 0.6s linear infinite;\n}\n\n@keyframes agg-node-form-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Compact: single column, larger touch targets, 16px inputs so iOS Safari\n   does not zoom the page when a field is focused. */\n@media (max-width: 640px) {\n  .agg-node-form__overlay {\n    align-items: flex-end;\n  }\n\n  .agg-node-form__grid {\n    grid-template-columns: minmax(0, 1fr);\n    row-gap: 0.875rem;\n  }\n\n  .agg-node-form__field--full {\n    grid-column: auto;\n  }\n\n  .agg-node-form__body {\n    padding: 1rem;\n  }\n\n  .agg-node-form__input,\n  .agg-node-form__select,\n  .agg-node-form__textarea {\n    font-size: 16px;\n    padding: 0.75rem 0.875rem;\n  }\n\n  .agg-node-form__buttons {\n    padding: 0.75rem 1rem;\n  }\n\n  .agg-node-form__button {\n    padding: 0.8125rem 1rem;\n    font-size: 0.9375rem;\n  }\n}\n\n/* Short landscape: the panel is still draggable but must fit the screen. */\n@media (max-height: 600px) {\n  .agg-node-form--panel {\n    max-height: calc(var(--app-height, 100dvh) - 1rem);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .agg-node-form__overlay,\n  .agg-node-form--sheet {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
